import { combineReducers } from 'redux';

import eventReducer from './event/reducer';

const reducers = combineReducers({
  event: eventReducer,
});

export default reducers;
